import GroupLayout from "./GroupLayout";

const BomisLayout = () => (
  <GroupLayout
    brandName="BOMIS"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/birla-logo-new.png"
    groupId="10000000034"
    headline="BOMIS Group of Schools"
  />
);

export default BomisLayout;
